// extracted by mini-css-extract-plugin
export default {"alertContainer":"PatientAlert_alertContainer__DYKAR","cards":"PatientAlert_cards__cj1GI","title":"PatientAlert_title__DoY8U","subtitle":"PatientAlert_subtitle__HPkdk"};